import { RootState } from 'src/apps/NewDriverApp/redux/root-reducer';

import { CameraReducerState } from './camera-reducer';

export const cameraSelector = (state: RootState): CameraReducerState => state.camera || {};
